import { request } from "../../utils/config"

export const CREATE_TODO = async (data) => {
  const response = await request({
    url: `TaskComments`,
    data: data,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const UPDATE_TODO = async (data) => {
  const response = await request({
    url: `TaskComments`,
    data: data,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const DELETE_TODO = async (id) => {
  const response = await request({
    url: `TaskComments?id=${id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
